import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import '../styles/Sidebar.scss';
import { useState, useEffect } from 'react';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import MonitorWeightIcon from '@mui/icons-material/FitnessCenter';
import EditIcon from '@mui/icons-material/Edit';
import ParaglidingIcon from '@mui/icons-material/Paragliding';

export default function Sidebar(props) {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [steps, setSteps] = useState('');
    const [cardio, setCardio] = useState('');
    const [weight, setWeight] = useState('');
    const [pressups, setPressups] = useState('');
    const [strength, setStrength] = useState(false);
    const [alcohol, setAlcohol] = useState(false);
    const [notes, setNotes] = useState('');

    var sidebarData = props.data;
    const today = require('dayjs')();

    // Populate fields with today's data
    useEffect(() => {
        if (sidebarData && sidebarData.length > 0) {
            const todayEntry = sidebarData.find(entry => {
                return parseInt(entry.activity_date_year) === currentDate.getFullYear() &&
                       parseInt(entry.activity_date_month) === (currentDate.getMonth() + 1) &&
                       parseInt(entry.activity_date_day) === currentDate.getDate();
            });
            
            if (todayEntry) {
                setSteps(todayEntry.activity_steps || '');
                setCardio(todayEntry.activity_bike || '');
                setWeight(todayEntry.activity_weight || '');
                setPressups(todayEntry.activity_pressups || '');
                setStrength(todayEntry.activity_strength || false);
                setAlcohol(todayEntry.activity_alcohol || false);
                setNotes(todayEntry.activity_notes || '');
            }
        }
    }, [sidebarData, currentDate]);

    // Load data for selected date
    function loadSidebarDataForDate(date) {
        if (sidebarData && sidebarData.length > 0) {
            const entry = sidebarData.find(entry => {
                return parseInt(entry.activity_date_year) === date.getFullYear() &&
                       parseInt(entry.activity_date_month) === (date.getMonth() + 1) &&
                       parseInt(entry.activity_date_day) === date.getDate();
            });
            if (entry) {
                setSteps(entry.activity_steps || '');
                setCardio(entry.activity_bike || '');
                setWeight(entry.activity_weight || '');
                setPressups(entry.activity_pressups || '');
                setStrength(entry.activity_strength || false);
                setAlcohol(entry.activity_alcohol || false);
                setNotes(entry.activity_notes || '');
            } else {
                setSteps('');
                setCardio('');
                setWeight('');
                setPressups('');
                setStrength(false);
                setAlcohol(false);
                setNotes('');
            }
        }
    }

    function handleSubmit(event) {
        event.preventDefault();

        console.log("Notes:", notes);
        
        var formData = {
            date: currentDate.toISOString().split('T')[0],
            activity_date_day: currentDate.getDate(),
            activity_date_month: currentDate.getMonth() + 1,
            activity_date_year: currentDate.getFullYear(),
            activity_steps: steps,
            activity_bike: cardio,
            activity_weight: weight,
            activity_pressups: pressups,
            activity_strength: strength,
            activity_alcohol: alcohol,
            activity_notes: notes
        };
        props.updateDatabaseByDate(formData, formData.activity_date_year, formData.activity_date_month, formData.activity_date_day);
    }

    return (
        <aside className="App-sidebar">
            <div className="sidebar-header">
                <h2>Add Activity</h2>
            </div>
            <div className="sidebar-content">
                <form className="activity-form">
                    <div className="form-group">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                id="activity-date"
                                defaultValue={today}
                                slotProps={{
                                    textField: { fullWidth: true }
                                }}
                                onChange={(newValue) => {
                                    setCurrentDate(newValue.toDate());
                                    loadSidebarDataForDate(newValue.toDate());
                                }}
                            />
                        </LocalizationProvider>
                    </div>
                    <div className="form-group">
                        <label htmlFor="activity-steps"><DirectionsWalkIcon style={{ fontSize: '14px', fill: " #38bdf8" }} />Steps </label>
                        <input type="number" id="activity-steps" name="activity-steps" min="0" value={steps} onChange={(e) => setSteps(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="activity-bike"><DirectionsBikeIcon style={{ fontSize: '14px', fill: "#c084fc" }} />Cardio (mins)</label>
                        <input type="number" id="activity-bike" name="activity-bike" min="0" value={cardio} onChange={(e) => setCardio(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="activity-weight"><MonitorWeightIcon style={{ fontSize: '14px', fill: "#fb923c" }} />Weight (lbs)</label>
                        <input type="number" id="activity-weight" name="activity-weight" min="0" value={weight} onChange={(e) => setWeight(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="activity-pressups"><ParaglidingIcon style={{ fontSize: '14px', fill: "#68d635", transform: "rotate(180deg)" }} />Pressups</label>
                        <input type="number" id="activity-pressups" name="activity-pressups" min="0" value={pressups} onChange={(e) => setPressups(e.target.value)} />
                    </div>
                    
                    <div className="checkbox-group">
                        <input type="checkbox" id="activity-strength" name="activity-strength" checked={strength} onChange={(e) => setStrength(e.target.checked)} />
                        <label htmlFor="activity-strength">Strength</label>
                    </div>
                    <div className="checkbox-group">
                        <input type="checkbox" id="activity-alcohol" name="activity-alcohol" checked={alcohol} onChange={(e) => setAlcohol(e.target.checked)} />
                        <label htmlFor="activity-alcohol">Alcohol</label>
                    </div>
                    <div className="textarea-group">
                        <label htmlFor="activity-notes"><EditIcon style={{ fontSize: '14px', fill: "#137fec" }} />Notes</label>
                        <textarea type="text" id="activity-notes" name="activity-notes" value={notes} onChange={(e) => setNotes(e.target.value)}></textarea>
                    </div>
                    <button type="submit" className="submit-button" onClick={handleSubmit}>Update</button>
                </form>
            </div>
        </aside>
    );
}
